<template>
  <div class="btnUpload"
       :class="{ 'error': errors.has('custom_file'), 'btnUpload--sm': sm, 'ajuste-padding': propItem }">
    <b-button v-if="btn"
              variant="outline-primary w-100"
              @click="$refs.file.click()">
      {{ label }}
    </b-button>
    <div v-show="!propItem"
         class="custom-file btnUpload_wrap">
      <input id="custom_file"
             ref="file"
             v-validate="'size:100000'"
             :accept="acceptedMimeTypes"
             class="custom-file-input btnUpload_input"
             :disabled="disabled"
             :multiple="!propItem"
             name="custom_file"
             type="file"
             @change="onChangeFiles">
      <label v-if="!btn"
             class="custom-file-label btnUpload_label"
             for="custom_file">{{ label }}</label>
      <small v-if="errors.has('custom_file')"
             class="invalid-feedback">{{ errors.first('custom_file') }}</small>
    </div>
  </div>
</template>

<script>
  import { ACCEPTED_MIME_TYPES } from '@/constants/fileUpload'

  export default {
    props: {
      disabled: {
        type: Boolean,
        default: null
      },
      label: {
        type: String,
        default: null
      },
      sm: {
        type: Boolean,
        default: null
      },
      btn: {
        type: Boolean,
        default: true
      },
      propItem: {
        type: Object,
        default: null
      }
    },
    data () {
      return {
        acceptedMimeTypes: ACCEPTED_MIME_TYPES.toString(),
      }
    },
    methods: {
      onChangeFiles (event) {
        const { files } = event.target
        const list = []

        if (files.length === 0) {
          return this.$emit('onSelectFiles', list)
        }

        for (let i of files) {
          list.push(i)
        }

        this.$validator.validateAll().then((result)=> {
          if (result) {
            if (this.propItem) {
              this.$emit('onSelectFiles', list, this.propItem)
              event.target.value = ''
            } else {
              this.$emit('onSelectFiles', list)
              // Precisamos resetar o campo para poder enviar os mesmos arquivos novamente
              // Ex.: O usuário excluiu o arquivo da lista e subiu o mesmo arquivo novamente
              // TODO: Criar unit test e apagar este comentário
              event.target.value = ''
            }

          }
        })
      },
      openUploadFile (itemId) {
        const referencia = this.$refs.ererer
        referencia.setFiles()
      }
    }
  }
</script>

<style lang="scss">
  @import '../../../scss/_utilities/exports';

  .btnUpload {
    &_wrap {}

    &_input {}

    &_label {
      text-indent: initial;

      &:before {
        background: transparent url('../../../assets/icons/file-upload.svg') center center;
        background-size: 100% 100%;
        bottom: 0;
        content: '';
        display: inline-block;
        height: pxToRem(24);
        margin-top: pxToRem(8);
        position: absolute;
        right: pxToRem(12);
        top: 0;
        width: pxToRem(24);
        z-index: 4;
      }

      &:after {
        padding-left: pxToRem(40);
      }
    }

    &--sm {
      .custom-file,
      .custom-file-input,
      .custom-file-label {
        font-size: pxToRem(12);
        height: pxToRem(31);
        padding-bottom: pxToRem(6);
        padding-top: pxToRem(6);
      }

      .custom-file-label {
        &:before {
          height: pxToRem(16);
          right: pxToRem(18);
          width: pxToRem(16);
        }
      }
    }
  }
  .ajuste-padding {
      padding: 0;
  }
</style>
